var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 18.334H15.0026V16.6673C15.0026 15.2866 13.8834 14.1673 12.5026 14.1673H7.5026C6.1219 14.1673 5.0026 15.2866 5.0026 16.6673V18.334H3.33594V16.6673C3.33594 14.3662 5.20142 12.5007 7.5026 12.5007H12.5026C14.8038 12.5007 16.6693 14.3662 16.6693 16.6673V18.334ZM10.0026 10.834C7.24118 10.834 5.0026 8.5954 5.0026 5.83398C5.0026 3.07256 7.24118 0.833984 10.0026 0.833984C12.764 0.833984 15.0026 3.07256 15.0026 5.83398C15.0026 8.5954 12.764 10.834 10.0026 10.834ZM10.0026 9.16732C11.8435 9.16732 13.3359 7.67493 13.3359 5.83398C13.3359 3.99303 11.8435 2.50065 10.0026 2.50065C8.16165 2.50065 6.66927 3.99303 6.66927 5.83398C6.66927 7.67493 8.16165 9.16732 10.0026 9.16732Z",
    fill: "black"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.2e84098bc486ad414b07074b4d64fdd2.svg";
export { ForwardRef as ReactComponent };